import script from "./ArchiveDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveDevices.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveDevices.vue?vue&type=style&index=0&id=e58c59a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58c59a2"]])

export default __exports__